import { render, staticRenderFns } from "./SplitSet.vue?vue&type=template&id=7bf0bb3a&scoped=true"
import script from "./SplitSet.vue?vue&type=script&lang=js"
export * from "./SplitSet.vue?vue&type=script&lang=js"
import style0 from "./SplitSet.vue?vue&type=style&index=0&id=7bf0bb3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf0bb3a",
  null
  
)

export default component.exports